document.addEventListener("DOMContentLoaded", function () {
  var sections = document.querySelectorAll(
    '[data-section-type="product-template"]',
  );
  if (!sections.length) return;

  sections.forEach(function (section) {
    var form = section.querySelector('form[action="/cart/add"]');
    var addToCart = form ? form.querySelector('button[name="add"]') : null;
    var oos = section.querySelector(".fivepetal-oos-notify");
    var qty = section.querySelector(".quantity-wrapper");
    var variantSelect = section.querySelector("select.original-selector");
    var dynamicPayment = section.querySelector(".shopify-payment-button");
    var oosSubmit = oos ? oos.querySelector('[data-oos-submit="true"]') : null;

    function update() {
      if (!oos) return;
      // If no variant selector (single-variant products), respect initial Liquid-rendered visibility
      if (!variantSelect) return;

      var selected = variantSelect.options[variantSelect.selectedIndex];
      var isOut = selected && selected.getAttribute("data-stock") === "out";

      // Only toggle visibility of the notify block. Keep add-to-cart, quantity and payment UI visible
      // so customers still see the disabled "Out of stock" state.
      if (isOut) {
        oos.style.display = "";
      } else {
        oos.style.display = "none";
      }
    }

    if (variantSelect) {
      variantSelect.addEventListener("change", update);
      update();
    }
    // For single-variant or no-variant products, run once on load
    if (!variantSelect) {
      update();
    }

    // Submit the customer form when arrow is clicked
    if (oos && oosSubmit) {
      oosSubmit.addEventListener("click", function (e) {
        e.preventDefault();
        var email = oos.querySelector('input[name="contact[email]"]');
        if (!email || !email.value) {
          if (email) email.focus();
          return;
        }
        var customerForm = oos.querySelector("form");
        if (customerForm) customerForm.submit();
      });
    }

    // Handle optional newsletter opt-in checkbox adding/removing the newsletter hidden field
    var form = oos ? oos.querySelector('form[action*="contact"]') : null;
    var optin = oos
      ? oos.querySelector('input[name="fivepetal_oos_newsletter_optin"]')
      : null;
    var newsletterHidden = function () {
      return form
        ? form.querySelector('input[type="hidden"][name="newsletter"]')
        : null;
    };
    function syncNewsletterHidden() {
      if (!form) return;
      var hidden = newsletterHidden();
      if (optin && !optin.checked) {
        if (hidden) hidden.parentNode.removeChild(hidden);
      } else {
        if (!hidden) {
          var h = document.createElement("input");
          h.type = "hidden";
          h.name = "newsletter";
          h.value = "true";
          form.insertBefore(h, form.firstChild);
        }
      }
    }
    if (optin) {
      optin.addEventListener("change", syncNewsletterHidden);
      syncNewsletterHidden();
    }
  });
});
